/**
 * @description - Function removes class 'active' from all given DOM elements
 *
 * @param {Object} items - given list of DOM elements
 */
const removeActiveClassFromItems = items => {
  $.each(items, (key, value) => {
    if ($(value).hasClass("active")) {
      $(value).removeClass("active");
    }
  });
};

/**
 * @description - Function adds class 'active' to given DOM element
 *
 * @param {string} item - element you look for
 */
const makeItemActive = item => {
  $(item).addClass("active");
};

/**
 * @description - Function that handles hover state on MegaMenu main nav
 *
 * @param {Object} nav - object with all DOM elements for main nav in MegaMenu
 * @param {Object} subNav - object with all DOM element for sub nav in MegaMenu
 */
const handleMegaMenuHoverState = (nav, subNav) => {
  const timeDelay = 200; // Time delay when user hovers on different tabs quickly [in ms]

  $.each(nav, (key, value) => {
    var timer;

    $(value).hover(
      () => {
        timer = setTimeout(() => {
          removeActiveClassFromItems(nav);
          removeActiveClassFromItems(subNav);
          makeItemActive(value);
          makeItemActive(subNav[key]);
        }, timeDelay);
      },
      () => {
        clearTimeout(timer);
      }
    );

    $(value).on('keyup', e => {
      e.preventDefault();

      if (e.keyCode === 32) {
        e.preventDefault();
        removeActiveClassFromItems(nav);
        removeActiveClassFromItems(subNav);
        makeItemActive(value);
        makeItemActive(subNav[key]);
      } else if (e.keyCode === 27) {
        // removeActiveClassFromItems(nav);
        // removeActiveClassFromItems($(value).find(megaMenuNav));
        // removeActiveClassFromItems($(value).find(megaMenuSubNav));
        // removeActiveClassFromItems(top);
        // makeItemActive($(value).find(megaMenuNav)[0]);
        // makeItemActive($(value).find(megaMenuSubNav)[0]);
      }
    });
  });
};

/**
 * @description - Function that handles hover state on Main Menu
 */
const handleMenuHoverState = () => {
  const nav = $(".header-navlist__item");
  const megaMenuNav = ".main-nav li";
  const megaMenuSubNav = ".sub-nav__item";
  const top = $(".top");
  const timeDelay = 200;

  $.each(nav, (key, value) => {
    var timer;
    $(value).hover(
      () => {
        timer = setTimeout(() => {
          removeActiveClassFromItems(nav);
          makeItemActive(value);
          makeItemActive(top);
          handleMegaMenuHoverState(
            $(value).find(megaMenuNav),
            $(value).find(megaMenuSubNav)
          );
        }, timeDelay);
      },
      () => {
        clearTimeout(timer);
      }
    );

    $(value).on('keyup', (e) => {
      e.preventDefault();
      if (e.keyCode === 13) {
        removeActiveClassFromItems(nav);
        makeItemActive(value);
        makeItemActive(top);
        handleMegaMenuHoverState(
          $(value).find(megaMenuNav),
          $(value).find(megaMenuSubNav)
        );
      } else if (e.keyCode === 27) {
        removeActiveClassFromItems(nav);
        removeActiveClassFromItems($(value).find(megaMenuNav));
        removeActiveClassFromItems($(value).find(megaMenuSubNav));
        removeActiveClassFromItems(top);
        makeItemActive($(value).find(megaMenuNav)[0]);
        makeItemActive($(value).find(megaMenuSubNav)[0]);
      }
    });

    top.on("mouseleave", () => {
      removeActiveClassFromItems(nav);
      removeActiveClassFromItems($(value).find(megaMenuNav));
      removeActiveClassFromItems($(value).find(megaMenuSubNav));
      removeActiveClassFromItems(top);
      makeItemActive($(value).find(megaMenuNav)[0]);
      makeItemActive($(value).find(megaMenuSubNav)[0]);
    });

    $(value)
      .find(".header-navlist__title")
      .click(e => {
        e.preventDefault();
      });
  });
};

handleMenuHoverState();
